import React from 'react';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="relative w-full border-t border-line bg-bg text-ink">
      <div className="container mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="inline-block w-2 h-2 bg-accent" />
          <span className="font-display font-bold text-xl">
            Sooraj Tharumia<span className="text-accent">.</span>
          </span>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="https://www.linkedin.com/in/soorajtharumia/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
            className="w-10 h-10 flex items-center justify-center border border-line text-ink-muted hover:text-accent hover:border-accent transition-colors"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://github.com/soorajtharumia"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="w-10 h-10 flex items-center justify-center border border-line text-ink-muted hover:text-accent hover:border-accent transition-colors"
          >
            <FaGithub />
          </a>
          <a
            href="mailto:sendsooraj@gmail.com"
            aria-label="Email"
            className="w-10 h-10 flex items-center justify-center border border-line text-ink-muted hover:text-accent hover:border-accent transition-colors"
          >
            <FaEnvelope />
          </a>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
